// NotFound.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from '@/Components/ui/container';
import { Stack } from '@/Components/ui/layout';
import { Heading, Text } from '@/Components/ui/typography';
import { Button } from '@/Components/ui/button';

const Notfound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-[94vh] bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex flex-col items-center justify-center text-white relative overflow-hidden w-[120%] -ml-[12%] py-5 px-8">
      <div className="fixed top-0 left-0 w-[1050%] h-[170%] after:content-[''] after:absolute after:w-0.5 after:h-0.5 after:bg-white after:shadow-[0_0_10px_white,100px_100px_0_white,200px_50px_0_white,300px_200px_0_white,400px_150px_0_white,500px_300px_0_white,600px_100px_0_white,700px_200px_0_white,800px_150px_0_white,900px_300px_0_white] after:animate-pulse" />
      <div className="flex items-center gap-5 mb-10">
        <div className="text-[120px] font-bold text-green-400 drop-shadow-[0_0_20px_rgba(80,197,152,0.5)] animate-bounce">4</div>
        <div className="w-[120px] h-[160px] relative animate-spin" style={{ animationDuration: '20s' }}>
          <div className="w-20 h-20 bg-white rounded-full absolute top-0 left-5" />
          <div className="w-[100px] h-[120px] bg-white rounded-[40px] absolute bottom-0 left-2.5" />
        </div>
        <div className="text-[120px] font-bold text-green-400 drop-shadow-[0_0_20px_rgba(80,197,152,0.5)] animate-bounce">4</div>
      </div>
      <Stack spacing="md" align="center">
        <Heading level="h2" size="3xl" className="my-5 font-comic animate-bounce !text-white drop-shadow-[0_0_12px_rgba(80,197,152,0.35)]">
          Houston, we have a problem!
        </Heading>
        <Text size="xl" className="text-slate-400 mb-8">
          The page you're looking for has floated away into space...
        </Text>
        {/* <Button 
          className="bg-green-500 text-white py-3 px-6 rounded-lg text-lg font-semibold cursor-pointer transition-all hover:bg-green-600 hover:scale-105"
          onClick={() => navigate('/')}
        >
          Return to Earth 🚀
        </Button> */}
      </Stack>
    </div>
  );
};

export default Notfound;